// src/authConfig.js
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri:
      window.location.hostname === "localhost"
        ? `${window.location.origin}/signin-oidc`
        : `https://${process.env.REACT_APP_APP_GATEWAY_URL}/signin-oidc`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["api://05f6372d-04d5-492c-bc72-0b664344f65d/access"],
};

export const cryptoAvailable =
  typeof window !== "undefined" && !!window.crypto?.subtle;

export const msalInstance = cryptoAvailable
  ? new PublicClientApplication(msalConfig)
  : null;
